import { useMutation } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";
import { SET_GROUP_ADMIN } from "../../mutations/rolesAndPermissions/setGroupAdmin";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";

export const useSetGroupAdmin = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [setGroupAdmin, { data, loading, error }] = useMutation(
    SET_GROUP_ADMIN,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_USER_GROUPS, GET_USER_GROUP, GET_USERS],
      awaitRefetchQueries: true,
    },
  );

  return { setGroupAdmin, data, loading, error };
};
